
import React from 'react';
import { Button } from '@/components/ui/button';
import { Scissors, X } from 'lucide-react';

interface EdgeContextMenuProps {
  x: number;
  y: number;
  visible: boolean;
  onDelete: () => void;
  onClose: () => void;
}

export default function EdgeContextMenu({
  x,
  y,
  visible,
  onDelete,
  onClose,
}: EdgeContextMenuProps) {
  if (!visible) return null;

  return (
    <div
      className="fixed z-50 min-w-[10rem] overflow-hidden rounded-md border bg-white shadow-lg"
      style={{
        left: x,
        top: y,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="p-1">
        <div
          className="relative flex cursor-pointer select-none items-center rounded-sm px-3 py-2 text-sm outline-none hover:bg-red-50 hover:text-red-600 transition-colors text-red-600"
          onClick={onDelete}
        >
          <Scissors className="w-4 h-4 mr-2" />
          Cortar Conexão
        </div>
      </div>
    </div>
  );
}
